import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(home)/where-to-go/[shipper]/[id]/search/page.tsx");
